import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';

// GHL appointment statuses BFY can set (ticket 143 P2). The page's
// changeStatus handler does the write (optimistic, ticket 189: the new value
// shows at once and goes back if GHL refuses); this is only the control.
export const STATUS_STYLE = {
  confirmed: 'bg-emerald-50 text-emerald-700',
  showed: 'bg-sky-50 text-sky-700',
  noshow: 'bg-amber-50 text-amber-700',
  cancelled: 'bg-slate-100 text-slate-500',
};

export const STATUS_OPTIONS = [
  { value: 'confirmed', label: 'Confirmed' },
  { value: 'cancelled', label: 'Cancelled' },
  { value: 'showed', label: 'Showed' },
  { value: 'noshow', label: 'No-show' },
];

// GHL rows get the dropdown; anything else shows its status read-only.
export default function StatusSelect({ appointment: a, saving, onChange, testId }) {
  const status = (a.status || '').toLowerCase();
  const style = STATUS_STYLE[status] || 'bg-slate-100 text-slate-600';
  if (a.source !== 'ghl') {
    return a.status
      ? <span className={`text-[10px] uppercase font-semibold rounded-full px-2 py-0.5 ${style}`}>{a.status}</span>
      : '—';
  }
  return (
    <Select value={status} disabled={saving} onValueChange={(v) => onChange(a, v)}>
      <SelectTrigger
        data-testid={testId}
        className={`h-7 w-auto min-w-[7.5rem] text-[10px] uppercase font-semibold rounded-full border-0 px-2 py-0.5 ${style} ${saving ? 'opacity-60' : ''}`}
      >
        <SelectValue placeholder={a.status || '—'} />
      </SelectTrigger>
      <SelectContent>
        {STATUS_OPTIONS.map((o) => (
          <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
